import React from "react";

export default function AvisoDePrivacidad() {
  return (
    <div className="container py-4">
      <div className="secretaria_funciones">
        <h3 className="title">Aviso de Privacidad</h3>
        <hr className="hr-gob" />
      </div>
      <div>
        <p>
          <strong>
            Propósito por el cual se recaban sus datos personales y protección
            de los mismos
          </strong>
        </p>
        <p>
          <strong>
            La Dirección de Tecnologías de la Información y Comunicaciones,
          </strong>{" "}
          perteneciente la Comisión de Agua y Alcantarillado de Sistemas
          Intermunicipales, ubicada en
          <strong>
            Av. Industrial La Paz No. 200 Col. Industrial la Paz, Pachuca,
            Hidalgo
          </strong>{" "}
          es la responsable del uso y protección de sus datos personales con
          fundamento en el Artículo 67 de la Ley de Transparencia y Acceso a la
          Información Pública para el Estado de Hidalgo así como a la Ley de
          Protección de Datos Personales en Posesión de Sujetos Obligados para
          el Estado de Hidalgo en sus artículos 1°, 3° fracciones I y XXX, 34,
          35 y 39 informándole lo siguiente:
        </p>
        <p>
          Los datos personales que recabamos y utilizamos de usted, son
          necesarios para el servicio y/o trámite que solicita, y los
          utilizaremos para las siguientes{" "}
          <strong>
            finalidades de conformidad al fundamento legal referido en cada una
            de ellas:
          </strong>
        </p>
        <ul>
          <li>
            <strong>
              <u>
                Registro y acceso a la plataforma del servicio en línea para
                consulta de consumo de agua, realizar pagos, facturación y
                descarga de recibos de pago.
              </u>
            </strong>{" "}
            - Artículo 34 frac. VI del Estatuto Orgánico.
          </li>
          <li>
            <strong>
              <u>Cumplir con las obligaciones fiscales de ésta empresa.</u>
            </strong>{" "}
            - Artículo 1o. de la Ley de Impuesto al Valor Agregado.
          </li>
          <li>
            <strong>
              <u>Generar la facturación.</u>
            </strong>{" "}
            - Artículos 29-A, 29 párrafos 1° y 2º fracción VI; 29 párrafos 1° y
            2º de la fracción IV y penúltimo párrafo del Código Fiscal de la
            Federación y 39 de su Reglamento; y 76 frac. II de la Ley del
            Impuesto Sobre la Renta.
          </li>
        </ul>
        <p>
          <strong>Nota:</strong> Le informamos que, si usted no manifiesta su
          negativa para llevar a cabo el tratamiento descrito en los apartados
          anteriores, entenderemos que ha otorgado su consentimiento para
          hacerlo; salvo lo establecido por los Artículos 19 y 98 por causas de
          excepción previstas en la citada ley de protección de datos
          personales.
        </p>
        <p>
          Para llevar a cabo las finalidades descritas en el presente Aviso de
          Privacidad, utilizaremos los siguientes datos personales:{" "}
        </p>
        <ol><strong>
          <li>1. Nombre Completo o Razón Social</li>
          <li>
            Domicilio fiscal {"("}Calle, No. exterior, No. interior, Colonia,
            Código Postal, Localidad y Municipio{")"}
          </li>
          <li>R.F.C.</li>
          <li>Correo electrónico</li>
          <li>
            Número telefónico de contacto {"("}celular o fijo{")"}
          </li>
          </strong>
        </ol>
        <p>
          Además de los datos personales descritos, le informamos que no
          utilizaremos datos personales sensibles.
        </p>
        <p>
          <strong>Cláusula de transferencia:</strong> No existen transferencias
          que requieran su consentimiento; se le informa que sus datos
          personales serán compartidos, para las finalidades que se indican de
          conformidad a lo siguiente:
        </p>
        <ul>
          <li>
            <u>
              <strong>
                Con el Servicio de Administración Tributaria {"("}S.A.T.{")"}.-
              </strong>
            </u>{" "}
            Cumplir con las obligaciones fiscales; {"("}cotejando sus datos
            personales proporcionados con los registrados en el SAT y verificar
            que estos sean correctos{")"}.- Artículos 29 del Código Fiscal de la
            Federación Párrafo Primero y Segundo fracción IV y Penúltimo
            párrafo; 26 Frac. XV y 34 Frac VI del Estatuto Orgánico de CAASIM.
          </li>
          <li>
            <u>
              <strong>
                Con la Subdirección de Presupuesto, Contabilidad y Finanzas de
                la CAASIM:
              </strong>
            </u>{" "}
            Cumplir con las disposiciones fiscales y efectuar el registro de las
            operaciones contables de CAASIM. - Artículos 30 del Código Fiscal de
            la Federación; 2 de la Ley General de Contabilidad Gubernamental; 76
            fracción I de la Ley del Impuesto Sobre la Renta; y 29 fracción VI
            del Estatuto Orgánico
          </li>
        </ul>
        <p>
          La última actualización y/o modificación del presente aviso es la
          indicada al final del mismo, situación que también podrá informarse
          directamente en las oficinas de esta área responsable de la protección
          de sus datos o a través de la página web institucional
          https://servicioscaasim.hidalgo.gob.mx/
        </p>
        <p>
          Usted tiene derecho a conocer qué datos personales tenemos de usted,
          para qué los utilizamos y las condiciones del uso que les damos
          <strong>{" "}
            {"("}acceso{")"}
          </strong>
          . Asimismo, es su derecho solicitar la corrección de su información
          personal en caso de que esté desactualizada, sea inexacta o incompleta{" "}
          <strong>
            {"("}rectificación{")"}
          </strong>
          ; que la eliminemos de nuestros registros o bases de datos cuando
          considere que la misma no está siendo utilizada conforme a los
          principios, deberes y obligaciones previstas en la normativa{" "}
          <strong>
            {"("}cancelación{")"}
          </strong>
          ; así como oponerse al uso de sus datos personales para fines
          específicos{" "}
          <strong>
            {"("}oposición{")"}
          </strong>
          . Estos derechos se conocen como derechos <strong>ARCO</strong>.
        </p>
        <p>
          Los datos de contacto de la Unidad de Transparencia del Poder
          Ejecutivo, quién gestionará las solicitudes para el ejercicio de
          derechos ARCO, asimismo auxiliará y orientará respecto al ejercicio
          del derecho a la protección de datos personales, son los siguientes:
          Carretera a la Estanzuela S/N San Agustín Tlaxiaca, Hgo. C.P. 42162 E-mail:{" "}
          <a href="mailto:uipg@hidalgo.gob.mx">
            uipg@hidalgo.gob.mx
          </a>
        </p>
      </div>
    </div>
  );
}
